import React from 'react'
import './MercosulPlate.scss'

export interface MercosulPlateProps {
  licensePlate: string
  size: 'X' | 'M' | 'S'
}

const MercosulPlate: React.FC<MercosulPlateProps> = ({
  licensePlate,
  size,
}) => {
  return (
    <div className='mercosul-plate-container'>
      <div className={`mercosul-plate-${size}`}>
        <strong className={`license-plate-text-${size}`}>{licensePlate}</strong>
      </div>
    </div>
  )
}

export default MercosulPlate
